import React from "react";
import { Box, TextField, Radio, Checkbox, IconButton, Tooltip } from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import FilterTagsInput from "./FilterTagsInput";

// `locked` — a segment-linked question's choice: the segment owns its text, so
// it can be neither edited nor removed here.
function ChoiceItem({ choice, choiceIndex, questionIndex, handleChoiceChange, handleRemoveChoice, isMultiChoice = false, locked = false }) {
  // Handle adding a filter tag
  const handleAddFilterTag = (newTag) => {
    handleChoiceChange(questionIndex, choiceIndex, "tags", [
      ...choice.tags,
      newTag,
    ]);
  };

  // Handle deleting a filter tag
  const handleDeleteFilterTag = (tagToDelete) => {
    handleChoiceChange(
      questionIndex,
      choiceIndex,
      "tags",
      choice.tags.filter((tag) => tag !== tagToDelete)
    );
  };

  return (
    <Box sx={{ display: "flex", flex: 1, p: 1, borderRadius: 2, alignItems: "center", justifyContent: "space-between" }}>
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 2 }}>
        {isMultiChoice ? (
          <Checkbox
            disabled
            sx={{
              p: 0,
              '& .MuiSvgIcon-root': { borderRadius: 0 },
            }}
          />
        ) : (
          <Radio
            disabled
            sx={{ p: 0 }}
          />
        )}
        <TextField
          value={choice.text}
          onChange={(e) =>
            handleChoiceChange(questionIndex, choiceIndex, "text", e.target.value)
          }
          variant="outlined"
          placeholder={`Choice ${choiceIndex + 1}`}
          size="small"
          InputProps={{ readOnly: locked }}
          sx={{
            width: "200px",
            "& .MuiOutlinedInput-root": {
              borderRadius: "4px",
              backgroundColor: "#fff",
              fontSize: "0.875rem",
            },
          }}
        />
      </Box>
      {!locked && (
        <Tooltip title="Remove this choice">
          <IconButton
            onClick={() => handleRemoveChoice(questionIndex, choiceIndex)}
            size="small"
            sx={{ color: "#d32f2f" }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
}

export default ChoiceItem;
